import { DeckTypeInput } from '@eti/schema-types';
const deckValues = {
  UPPER_DECK: 'upperDeck',
  MAIN_DECK: 'mainDeck',
  LOWER_DECK: 'lowerDeck'
};
const supportedDecks = [deckValues.UPPER_DECK, deckValues.MAIN_DECK, deckValues.LOWER_DECK];
const hasCabins = val => {
  var _val$cabins$length, _val$cabins;
  return val != null && typeof val === 'object' && 'cabins' in val && ((_val$cabins$length = (_val$cabins = val.cabins) === null || _val$cabins === void 0 ? void 0 : _val$cabins.length) !== null && _val$cabins$length !== void 0 ? _val$cabins$length : 0) > 0;
};
export const getDefaultDeck = options => {
  var _options$find;
  return (_options$find = options.find(deck => deck.value === deckValues.MAIN_DECK)) !== null && _options$find !== void 0 ? _options$find : options[0];
};
export const getDeckType = option => {
  var _deckTypeMap$option$v;
  if (!(option !== null && option !== void 0 && option.value)) {
    return null;
  }
  const deckTypeMap = {
    [deckValues.LOWER_DECK]: DeckTypeInput.LowerDeck,
    [deckValues.MAIN_DECK]: DeckTypeInput.MainDeck,
    [deckValues.UPPER_DECK]: DeckTypeInput.UpperDeck
  };
  return (_deckTypeMap$option$v = deckTypeMap[option.value]) !== null && _deckTypeMap$option$v !== void 0 ? _deckTypeMap$option$v : null;
};
export const getDeckOptionForDeckType = (deckType, options) => {
  if (!deckType) {
    return undefined;
  }
  return options.find(option => getDeckType(option) === deckType);
};
export const getAvailableDeckOptionsForSegment = (segments, boundSegmentIndex, upperDeckLabel, mainDeckLabel, lowerDeckLabel) => {
  const currentSegment = segments.find(segment => segment.boundSegmentIndex === boundSegmentIndex);
  if (!currentSegment || !upperDeckLabel || !mainDeckLabel || !lowerDeckLabel) {
    return [];
  }
  const labels = {
    [deckValues.UPPER_DECK]: upperDeckLabel,
    [deckValues.MAIN_DECK]: mainDeckLabel,
    [deckValues.LOWER_DECK]: lowerDeckLabel
  };
  return Object.entries(currentSegment).filter(([key, val]) => supportedDecks.includes(key) && hasCabins(val)).map(([key]) => ({
    label: labels[key],
    value: key
  }));
};
//# sourceMappingURL=deckUtils.js.map